/** @jsx jsx */
// eslint-disable-next-line
import React, { Component } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { css, jsx } from '@emotion/core'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { theme } from '../../../constants'
import OrganizationService from '../../../services/organization'
import * as Actions from '../../admin/actions'

const styles = {}

styles.blockingOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
`

styles.box = css`
  position: absolute;
  width: 700px;
  color: ${theme.palette.common.charolBlack};
  border-radius: 5px;
  padding: 30px 60px;
  background: white;
  border: 10px solid lightgray;
  pointer-events: all;
`

styles.title = css`
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 25px;
`

styles.descriptionTableContainer = css`
  display: flex;
  flex-wrap: wrap;
`

styles.descriptionContainer = css`
  font-size: 14px;
  margin: 10px 0px;
`

styles.actionContainer = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`

styles.actionButton = css`
  height: 24px;
  padding: 0px 20px;
  text-transform: none;
  font-size: 14px;
  background: ${theme.palette.common.blue};
  color: ${theme.palette.common.white};

  &:hover {
    background: ${theme.palette.common.blue2};
  }
`

styles.cancelButton = css`
  height: 24px;
  padding: 0px 20px;
  margin-right: 15px;
  text-transform: none;
  font-size: 14px;
  background: transparent;
  color: ${theme.palette.common.blue};
  box-shadow: none;

  &:hover {
    background: transparent;
  }
`

styles.loaderContainer = css`
  display: flex;
  color: white;
  margin-right: 10px;
`

styles.error = css`
  color: ${theme.palette.error.main};
  height: 20px;
  text-align: right;
  font-size: 14px;
`

function DeleteOrganizationModal(props) {
  const [isEnabled, setIsEnabled] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [showError, setShowError] = React.useState('')

  async function onSubmit() {
    // On submit, show loader and disable submit to not perform many retries with the same key.
    setIsLoading(true)
    setIsEnabled(false)

    try {
      const payload = { id: props.organization._id }
      await OrganizationService.deleteOrganization(props.ownerOrganization._id, payload)

      // Reload UI.
      await Actions.updateUser()
      onClose()
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message
      if (message) {
        setShowError(message)
        if (!showError) {
          setTimeout(() => setShowError(''), 5000)
        }

        setIsLoading(false)
      } else {
        console.error(error)
        toast.error(window.I18n.t('groups.deleteErrorMessage'))
        onClose()
      }
    }
  }

  function onClose() {
    props.onApply()
  }

  return (
    <div css={styles.blockingOverlay}>
      <div css={styles.box}>
        <span css={styles.title}>{window.I18n.t('groups.deleteGroup')}</span>
        <div
          css={styles.descriptionContainer}
          dangerouslySetInnerHTML={{
            __html: window.I18n.t('groups.deleteGroupDescription', {
              name: props.organization.name,
              pre: '<b>',
              post: '</b>'
            })
          }}
        />

        <div css={styles.error}>{showError}</div>
        <div css={styles.actionContainer}>
          <Button
            color="primary"
            variant="contained"
            css={styles.cancelButton}
            disabled={isLoading}
            onClick={onClose}
          >
            {window.I18n.t('common.cancel')}
          </Button>
          <Button css={styles.actionButton} onClick={onSubmit}>
            {isLoading && (
              <div css={styles.loaderContainer}>
                <CircularProgress size={16} thickness={4} color="inherit" />
              </div>
            )}
            {window.I18n.t('groups.deleteNow')}
          </Button>
        </div>
      </div>
    </div>
  )
}

DeleteOrganizationModal.propTypes = {
  organization: PropTypes.object.isRequired,
  ownerOrganization: PropTypes.object.isRequired,
  onApply: PropTypes.func.isRequired
}

export default DeleteOrganizationModal
